const ACCESS_TOKEN_KEY = 'gate.haus.access_token';

const resolveStorage = () => {
  try {
    const storage = localStorage;
    storage.setItem('__gh_test__', '1');
    storage.removeItem('__gh_test__');
    return storage;
  } catch (error) {
    return sessionStorage;
  }
};

const storage = resolveStorage();

export const tokenStore = {
  get: () => storage.getItem(ACCESS_TOKEN_KEY),
  set: (token: string) => storage.setItem(ACCESS_TOKEN_KEY, token),
  clear: () => storage.removeItem(ACCESS_TOKEN_KEY)
};
